import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { AxiosError } from "axios";

type CategoryOptionProps = {
    id: number,
    name: string
    order: number,
    categoryId: number,
}

async function update(data: CategoryOptionProps): Promise<void> {
    try {
        await ApiClient({ url: `categories/${data.categoryId}/options/${data.id}`, method: "PUT", data: { name: data.name, order: data.order } });
    } catch (error) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An unexpected error occurred");
    }
}

export function usePutOptionMutation(onSuccess: () => void, onError: (error: Error) => void) {
    return useMutation<void, Error, CategoryOptionProps>({
        mutationKey: ["put-option"],
        mutationFn: update,
        onSuccess,
        onError
    });
}